import clsx from 'clsx';
import { useState } from 'react';

const IRON_NEW_PROGRAM_LINK = 'https://www.example.com/programs/new';

export const ProgramDropdown = (ps: {
  label: string;
  value: string | number;
  onChange: (v: string | number) => void;
  options: string[];
  required?: boolean;
  theme?: 'valid' | 'error' | 'warning' | 'scheduled';
}) => {
  const [open, setOpen] = useState(false);

  const text_color = clsx(
    ps.theme === 'error' && 'text-red-500',
    ps.theme === 'warning' && 'text-yellow-500',
    ps.theme === 'valid' && 'text-green-500',
    ps.theme === 'scheduled' && 'text-blue-500',
    !ps.theme && 'text-neutral-500',
  );

  const border_color = clsx(
    ps.theme === 'error' && 'border-red-500',
    ps.theme === 'warning' && 'border-yellow-500',
    ps.theme === 'valid' && 'border-green-500',
    ps.theme === 'scheduled' && 'border-blue-500',
    !ps.theme && 'border-neutral-300',
  );

  const bg_color = clsx(
    ps.theme === 'error' && 'bg-red-100',
    ps.theme === 'warning' && 'bg-yellow-100',
    ps.theme === 'valid' && 'bg-green-100',
    ps.theme === 'scheduled' && 'bg-blue-100',
    !ps.theme && 'bg-transparent',
  );

  return (
    <div className={'flex flex-col gap-2 select-none'}>
      <label className={clsx('text-sm', text_color)}>
        {ps.label}
        {ps.required && <span>*</span>}
      </label>
      <div
        className={clsx(
          'relative rounded-lg border-2 text-black',
          border_color,
          bg_color,
        )}
        onClick={() => setOpen(!open)}>
        <div className="flex items-center justify-between p-2 cursor-pointer">
          <span>{ps.value || '-'}</span>
          <span
            className={clsx(
              'text-neutral-500 transition-transform duration-100',
              open ? 'rotate-180' : 'rotate-0',
            )}>
            ▼
          </span>
        </div>
        <div
          id="program-options"
          className={clsx(
            'absolute w-full left-0 top-[110%] flex flex-col border-2 h-40 overflow-auto',
            !open && 'hidden',
          )}>
          <div
            className={clsx(
              'p-2 w-full text-sm cursor-pointer hover:font-bold hover:bg-blue-100',
            )}
            onClick={() => window.open(IRON_NEW_PROGRAM_LINK, '_blank')}>
            Aggiungi programma...
          </div>
          {ps.options.map((o) => (
            <div
              key={o}
              className={clsx(
                'p-2 w-full text-sm cursor-pointer',
                ps.value === o
                  ? 'bg-neutral-400 text-white'
                  : 'hover:font-bold hover:bg-neutral-100',
              )}
              onClick={() => ps.onChange(o)}>
              {o}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
